import React, { useEffect, createContext, useContext } from 'react';
import log from '../../utils/log';

export const FormContext = createContext({});

/**
 * A custom hook to abstract the process of registering a field component to the closet EndUserForm.
 *
 * The first parameter is the internal ID of the field, so that the validation can find the DOM node containing the latest value.
 *
 * The second parameter is the validator function. The validator takes the latest value as an argument and returns a string, either a validation error message or `""` for no error.
 *
 * If the component calling `useField` expects to rerender itself, it should wrap the validator in `useCallback` so that it doesn't trigger `useEffect` repeatedly.
 *
 * @param {string} id the internalId of the field
 * @param {fn} validator memoized function for validating input values
 */
export const useField = (id, validator) => {
  const { registerField } = useContext(FormContext);

  useEffect(() => {
    registerField(id, validator);
  }, [registerField, id, validator]);
};
